// @ts-nocheck d7011be6
import reducer from './userProfileReducer';
import * as selectors from './userProfileSelectors';
import * as actions from './userProfileActions';

export { reducer, selectors, actions };
